import React, { FC, useCallback } from "react";

import { WebsiteQuestionStep, WebsiteQuestionStepProps } from "../../components/V3/WebsiteQuestionStep";

import { OnboardingProps } from "../../models";

export interface WebsiteQuestionStepContainerProps
    extends Pick<WebsiteQuestionStepProps, "aside" | "style" | "className"> {
    initialProps?: OnboardingProps;

    onNext(props: OnboardingProps): void;
    onBack?(): void;
}

export const WebsiteQuestionStepContainer: FC<WebsiteQuestionStepContainerProps> = (props) => {
    const { initialProps, onNext, onBack } = props;

    const handleWebsite = useCallback(
        (hasWebsite: boolean, website?: string) => {
            onNext({
                ...initialProps,
                website,
                beta: {
                    ...initialProps?.beta,
                    onboarding: {
                        ...initialProps?.beta?.onboarding,
                        hasWebsite,
                    },
                },
            });
        },
        [initialProps, onNext]
    );
    const handleBack = useCallback(() => {
        if (typeof onBack === "function") {
            onBack();
        }
    }, [onBack]);

    const website = initialProps?.website || "";

    return <WebsiteQuestionStep {...props} initialValue={website} onNext={handleWebsite} onBack={handleBack} />;
};
